window.config = require('@config/config.js')
const CONFIG = new config()
const store = {
    namespaced: true,
    state: {
        operator_node: {},
        requester_node: null,
        requester_contract: null,
        waybill_raw_datas: [],
        waybill_processed_datas: [],
        receivers: [],
        // converters
        converters: [],
        current_converter: null,
        conversions: [],
        // urls
        open_file_url: null,
        file_upload_url: "https://air.formosaas.com/api/v1/:app_id/cloud/:access_token/:identity/bucket/:bucket_identity/upload",
        fetch_converters_url: null,
        create_operation_url: null,
        use_waybill_url: null,
        validate_waybill_url: null,
        validator: "standard",
    },
    getters: {
    },
    actions: {
        set_urls(context, payload) {
            return new Promise(resolve => {
                var scope = context.rootState.current_scope
                // open_file_url
                context.commit(
                    'set_open_file_url',
                    context.rootState.customer.routes.api_v1_customer_file_converters_convert
                )
                // file_upload_url
                context.commit(
                    'set_file_upload_url',
                    new RestUrl(context.rootState.customer.uploader_module.file_upload_url).parse(
                        {
                            "app_id": context.rootState.customer.customer.air_service.air_app_id,
                            "access_token": context.rootState.customer.customer.air_service.air_access_token,
                            "identity": context.rootState.customer.customer.air_service.air_identity,
                            "bucket_identity": context.rootState.customer.customer.air_service.air_bucket_identity,
                            "air_authorization": context.rootState.customer.customer.air_service.air_authorization
                        },
                        "?authorization=" + context.rootState.customer.customer.air_service.air_authorization + "&is_froala=true"
                    )
                )
                // create_operation_url
                context.commit(
                    'set_create_operation_url',
                    context.rootState.customer.routes["api_v1_customer_operations_create"]
                )
                // fetch_converters_url
                context.commit(
                    'set_fetch_converters_url',
                    context.rootState.customer.routes["api_v1_customer_file_converters"]
                )
                // set_validate_waybill_url
                context.commit(
                    'set_validate_waybill_url',
                    context.rootState.customer.routes["api_v1_customer_core_waybills_usable_core_waybills"]
                )
                resolve()
            })
        },
        fetch_operator_node(context, payload) {
            context.commit('set_operator_node', context.rootState.customer.customer.provider_node)
        },
        fetch_requester_node(context, payload) {
            context.commit('set_requester_node', context.rootState.customer.customer)
        },
        fetch_converters(context, payload) {
            var scope = context.rootState.current_scope
            return axios.get(context.state.fetch_converters_url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    console.log(response)
                    if (response.data.status == "success") {
                        context.commit('set_converters', response.data.converters)
                    } else if (response.data.status == "failure") {
                    }
                })
                .catch(error => {
                })
        },
    },
    mutations: {
        set_open_file_url(state, payload) {
            state.open_file_url = payload
        },
        set_file_upload_url(state, payload) {
            state.file_upload_url = payload
        },
        set_create_operation_url(state, payload) {
            state.create_operation_url = payload
        },
        set_fetch_converters_url(state, payload) {
            state.fetch_converters_url = payload
        },
        set_validate_waybill_url(state, payload) {
            state.validate_waybill_url = payload
        },
        set_operator_node(state, payload) {
            state.operator_node = payload
        },
        set_requester_node(state, payload) {
            state.requester_node = payload
        },
        set_requester_contract(state, payload) {
            state.requester_contract = payload
        },
        set_conversions(state, payload) {
            state.conversions = payload
        },
        set_converters(state, payload) {
            state.converters = payload
        },
        set_waybill_raw_datas(state, payload) {
            state.waybill_raw_datas = payload
        },
        set_waybill_processed_datas(state, payload) {
            state.waybill_processed_datas = payload
        },
        set_receivers(state, payload) {
            state.receivers = payload
        },
        set_current_converter(state, payload) {
            state.current_converter = payload
        },
        init(state, payload) {
            state.operator_node = {}
            state.requester_node = null
            state.requester_contract = null
            state.waybill_raw_datas = []
            state.receivers = []
            state.conversions = []
            state.receivers = []
        }
    }
}

export default store
